import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./IPCameraVideoStreaming.module.css";
import moment from "moment";
import ScoreBox from "./ScoreBox";
import HoverToolTip from "../../../../Common/ToolTips/HoverToolTips/HoverToolTip";
import userService from "../../../../services/user.service";
import { getFromLocalStorage } from "../../../../utils/webStorage";
import { formatDuration } from "../../../../utils/formatTimeDuration";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  openVideoPopup,
  openFailDialog,
  openRenamePopup,
} from "../../../../Redux/Actions/PopupActions";
import {
  setOdkData,
  setRecording,
} from "../../../../Redux/Actions/VideoStreamingActions";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  CircularProgress,
} from "@mui/material";
const Footer = ({ socket, setLoadingButton, loadingButton }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const schoolId = getFromLocalStorage("schoolId");
  const adminRole = getFromLocalStorage("loginRole");
  const assignedRight = JSON.parse(getFromLocalStorage("assignedRights") || []);
  const assignedRights = assignedRight.map((item) => item.displayName);
  const [odkValue, setodkValue] = useState("none");
  const [recordingStatus, setRecordingStatus] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [loadRecording, setLoadRecording] = useState(false);
  const [startRecordingTime, setStartRecordingTime] = useState();
  const [recordingCount, setRecordingCount] = useState(0);
  const [navigationData, setNavigationData] = useState({});
  const {
    videoStreamAvsChannelList,
    video_Stream_Status,
    recording,
    dataForOdk,
  } = useSelector((state) => state?.videoStreamData);
  const currentSeason = useSelector(
    (state) => state.loggedInUser.userProfile.currentSeason
  );
  const videoScheduleInformation = useSelector(
    (state) => state?.videoScheduleInformation
  );

  const handleRadioChange = (event) => {
    setodkValue(event.target.value);
  };

  useEffect(() => {
    let timerInterval;
    if (recordingStatus) {
      timerInterval = setInterval(() => {
        setElapsedTime((prevElapsedTime) => {
          const updatedTime = prevElapsedTime + 1;
          //set 30 minute time limit
          if (updatedTime === 1800) {
            getRecordedClipUsingSocket();
          }
          return updatedTime;
        });
      }, 1000);
    } else if (!recordingStatus && elapsedTime !== 0) {
      clearInterval(timerInterval);
    }
    return () => clearInterval(timerInterval);
  }, [recordingStatus, elapsedTime]);

  useEffect(() => {
    const handleRecordingResponse = (data) => {
      const { odkValue: value, responsePayload } = data;
      const recordingData = responsePayload?.map((ele) => {
        return {
          ...ele,
          filePath: ele?.master_url,
          userId: schoolId,
        };
      });
      userService
        .uploadLiveStreamingDetails(recordingData)
        .then((response) => {
          const data = videoStreamAvsChannelList.filter(
            (ele) => ele.isPrimaryChannel == true
          )[0];
          //set navigation data for the first recording
          if (recording.length == 0) {
            setNavigationData(data);
          }
          const {
            eventType,
            eventName,
            practiceName,
            seasonType,
            scheduleId,
            seasonId,
            playlistId,
            isPractice,
          } = data;
          userService
            .saveScheduleEvent(
              eventType,
              schoolId,
              eventName,
              practiceName,
              response.data?.data,
              seasonType,
              scheduleId,
              isPractice,
              seasonId,
              false,
              playlistId,
              true
            )
            .then((result) => {
              let odk;
              switch (value) {
                case "O":
                  odk = "Offense";
                  break;
                case "D":
                  odk = "Defense";
                  break;
                case "K":
                  odk = "Kick";
                  break;
                default:
                  odk = "none";
              }
              const record = result.data.data.map((ele) => {
                return {
                  id: ele.id,
                  fileName: ele.eventMediaCategory,
                  filePath: ele.videoPath,
                  videoDuration: ele.videoDuration,
                  thumbnailUrl: ele.thumbnailUrl,
                  schoolId,
                  odk,
                };
              });
              setRecording(dispatch, record);
              socket.emit("newRecordings", record);
              setLoadRecording(false);
              //add breakdown values for ODK breakdown
              if (value !== "none") {
                let breakdownId = dataForOdk.breakdownId;
                let columnSetName = dataForOdk.columnName;
                let addBreakdownArray = result.data?.data?.map((ele) => {
                  return {
                    eventMediaId: ele.id,
                    eventId: ele.scheduleEvent.id,
                    schoolId,
                    breakdownId,
                    columnSetName,
                    value,
                  };
                });
                userService
                  .addBreakDownValuesToTable(addBreakdownArray)
                  .catch((error) => {
                    throw error;
                  });
              }
            });
        })
        .catch((error) => {
          setLoadRecording(false);
          setElapsedTime(0);
          setRecordingStatus(false);
          openFailDialog(dispatch, {
            open: true,
            message: "Something Went Wrong",
          });
        });
    };
    socket.on("recordingResponse", handleRecordingResponse);
    return () => {
      socket.off("recordingResponse", handleRecordingResponse);
    };
  }, [socket, videoStreamAvsChannelList, odkValue]);

  //set data to save recorded video in ODk breakdown
  useEffect(() => {
    userService
      .getDefaultODKBreakdownData(schoolId)
      .then((response) => {
        setOdkData(dispatch, response.data.data);
      })
      .catch((error) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Fail To Fetch ODK Data",
        });
      });
  }, []);

  const getRecordedClipUsingSocket = () => {
    const tempelapsedtime = elapsedTime;
    if (recordingStatus) {
      setElapsedTime(0);
      setRecordingStatus(false);
      setLoadRecording(true);
      let count = recordingCount + 1;
      setRecordingCount(count);
      let updatedChannelList = loadingButton
        ? videoStreamAvsChannelList.filter((ele) => loadingButton != ele?.id)
        : videoStreamAvsChannelList;
      let newChannelData = updatedChannelList.map((ele, index) => {
        let parts = ele.channelArn?.split("/");
        let channelId = parts[parts.length - 1];
        let startTime = Math.floor(
          (Date.parse(startRecordingTime) -
            Date.parse(ele?.streamingStartTime)) /
            1000
        );
        let endTime = Math.floor(startTime + tempelapsedtime);
        return {
          id: ele.id.toString(),
          channelId: channelId,
          angle: ele.angle,
          startTime,
          endTime,
          count,
        };
      });
      socket.emit("fetchRecording", {
        recordingData: newChannelData,
        byteRange: true,
        elapsedTime,
        odkValue,
        schoolId,
      });
    } else {
      setStartRecordingTime(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
      setRecordingStatus(true);
    }
  };

  const handleRenameVideo = (item) => {
    openRenamePopup(dispatch, {
      renamePopup: {
        open: true,
        type: "rename-recorded-video",
        recording: recording,
        item: item,
      },
    });
  };

  const groupedRecordings = recording.reduce((acc, item) => {
    const { odk } = item;
    if (!acc[odk]) {
      acc[odk] = [];
    }
    acc[odk].unshift(item); // Add new item to the front to ensure LIFO
    return acc;
  }, {});

  const handleNavigation = () => {
    const {
      eventName,
      practiceName,
      seasonType,
      playlistId,
      weekName,
      eventType,
    } = navigationData;
    switch (seasonType) {
      case "Other":
        history.push(
          `/videoplayer?season-year=${currentSeason?.years}&season-type=${seasonType}&event-type=${eventName}&playlist-id=${playlistId}`
        );
        break;

      case "Off-Season":
        history.push(
          `/videoplayer?season-year=${currentSeason?.years}&season-type=${seasonType}&eventname=${eventName}&practice=${practiceName}&playlist-id=${playlistId}`
        );
        break;

      case "In-Season":
        history.push(
          `/videoplayer?season-year=${currentSeason?.years}&season-type=${seasonType}&week=${weekName}&event-type=${eventType}&playlist-id=${playlistId}`
        );
        break;

      default:
        break;
    }
  };

  return (
    <>
      {videoStreamAvsChannelList.length > 0 && (
        <footer className={styles.footer}>
          <div className={styles.cameraStatusContainer}>
            <p className="semi-bold fs-22">
              <span className="link-blue">Active Cameras</span> :{" "}
              {videoStreamAvsChannelList?.length}
            </p>
            <FormControl>
              <FormLabel
                id="demo-radio-buttons-group-label"
                className="bold black fs-22"
              >
                Select Type :
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                value={odkValue}
                onChange={handleRadioChange}
              >
                <FormControlLabel
                  value="O"
                  control={<Radio />}
                  label="Offense (O)"
                />
                <FormControlLabel
                  value="D"
                  control={<Radio />}
                  label="Defense (D)"
                />
                <FormControlLabel
                  value="K"
                  control={<Radio />}
                  label="Kick (K)"
                />
                <FormControlLabel
                  value="none"
                  control={<Radio />}
                  label="None"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <ScoreBox />
          <div className={`fs-40  ${styles.streamingButtonContainer}`}>
            {recordingStatus && (
              <div className={`${styles.timer} shadow`}>
                <p className="semi-bold fs-35 white">
                  {formatDuration(elapsedTime)}
                </p>
              </div>
            )}
            {(adminRole === "SCHOOL ADMIN" ||
              assignedRights.includes("Record Video")) && (
              <HoverToolTip
                content={<span>Connect Camera to Start Streaming.</span>}
                showToolTip={videoStreamAvsChannelList?.length === 0}
                variant="sm"
                trigger="hover"
              >
                <button
                  className={`${styles.StreamingButton} 
                  ${recordingStatus ? styles.bgLightRed : styles.bgNavyBlue}`}
                  onClick={() => {
                    getRecordedClipUsingSocket();
                  }}
                  disabled={!video_Stream_Status}
                >
                  <RadioButtonCheckedIcon
                    className={styles.streamingButtonIcon}
                  />
                  <span>{recordingStatus ? "STOP" : "START"}</span>
                </button>
              </HoverToolTip>
            )}
          </div>
        </footer>
      )}
      {loadRecording && (
        <div className="d-flex flex-direction-c items-center gap-10">
          <h4 className={`${styles.loadRecording}`}>
            Hang tight, we are extracting recording
          </h4>
          <CircularProgress size="1.5rem" className="red" />
        </div>
      )}
      {recording.length != 0 && (
        <p className="semi-bold fs-20 p-20 pl-0">Your all recorded videos:</p>
      )}
      {Object.keys(groupedRecordings).map((category) => (
        <div key={category} className={`${styles.batchContainer}`}>
          <div className={`${styles.batchTitle}`}>
            <p className="bold">
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </p>
          </div>
          {groupedRecordings[category].map((item, index) => (
            <div className="recording-container" key={index}>
              <img src={item?.thumbnailUrl} className="video-thumbnail" />
              <span className="text-width-auto">{item?.fileName}</span>
              <p className="text-width-auto">
                {formatDuration(item?.videoDuration)}
              </p>
              <div className="d-flex-center gap-10">
                <button
                  className={`${styles.actionButton} video-preview-btn`}
                  onClick={(e) => {
                    e.stopPropagation();
                    openVideoPopup(dispatch, {
                      status: true,
                      videoURL: item?.filePath,
                    });
                  }}
                >
                  Preview
                </button>
                <button
                  className={`${styles.actionButton} video-preview-btn`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRenameVideo(item);
                  }}
                >
                  Rename
                </button>
              </div>
            </div>
          ))}
        </div>
      ))}
      {videoStreamAvsChannelList.length == 0 && recording.length !== 0 && (
        <div className="d-flex-center gap-20 mg-top-20">
          <button onClick={handleNavigation} className="saveBtn1">
            Navigate To The Playlist
          </button>
        </div>
      )}
    </>
  );
};

export default Footer;
